import { fmt, useT } from '../i18n'

import { Button } from './Button'

export function Pagination({
  total,
  limit,
  offset,
  onChange,
}: {
  total: number
  limit: number
  offset: number
  onChange: (offset: number) => void
}) {
  const { t } = useT()

  if (total <= limit && offset === 0)
    return (
      <div className="pagination">{fmt(t.common.total, { count: total })}</div>
    )
  const from = total ? offset + 1 : 0
  const to = Math.min(offset + limit, total)

  return (
    <div className="pagination">
      <span>{fmt(t.common.range, { from, to, total })}</span>
      <div className="row">
        <Button
          size="sm"
          brackets={false}
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - limit))}
        >
          {t.common.previous}
        </Button>
        <Button
          size="sm"
          brackets={false}
          disabled={to >= total}
          onClick={() => onChange(offset + limit)}
        >
          {t.common.next}
        </Button>
      </div>
    </div>
  )
}
